import React, { useContext } from 'react';
import * as _ from 'lodash';
import { Menu, Transition } from '@headlessui/react';
import { AuthContext } from '../../../context/AuthContext';
import { GetFeatureState } from '../../../hooks/getFeatureState';
import { Link } from 'react-router-dom';
import { ChevronDownIcon } from '@heroicons/react/outline';

const UserMenu: React.FC = () => {
  const { logout, account } = useContext(AuthContext);
  const SupportSectionEnabled = GetFeatureState('SupportSection');

  return (
    <Menu>
      {({ open }) => (
        <div className="ml-3 relative z-50">
          <div>
            <Menu.Button
              className="flex items-center justify-between border border-gray-300 rounded-full pr-2 hover:border-gray-300 hover:bg-gray-50"
              aria-haspopup="true"
            >
              <span className="sr-only">Open user menu</span>
              <div className="bg-gray-600 rounded-full flex text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-primary-light focus:ring-white">
                {_.get(account, 'user.person.avatar.filePath', null) ? (
                  <img
                    className="h-8 w-8 rounded-full"
                    src={_.get(account, 'user.person.avatar.filePath', '')}
                    alt="Headshot"
                  />
                ) : (
                  <svg
                    className="h-8 w-8 rounded-full text-gray-300"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                )}
              </div>
              <div className="px-3 text-gray-500 text-sm font-light tracking-wide">
                {account?.user?.person?.name?.full || ''}
              </div>
              <ChevronDownIcon className="w-3 text-gray-500" />
            </Menu.Button>
          </div>
          <Transition
            show={open}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items
              static
              className="absolute right-0 w-56 mt-2 origin-top-right bg-white border border-gray-200 divide-y divide-gray-100 rounded-md shadow-lg outline-none"
            >
              <div className="px-4 py-3 text-gray-500">
                <p className="text-xs leading-5">Signed in as</p>
                <p className="text-sm leading-5 text-gray-600 truncate">
                  {_.get(account, 'user.person.email', '')}
                </p>
              </div>

              <div className="py-1">
                <Menu.Item>
                  {({ active }) => (
                    <Link
                      to="/account"
                      className={`${
                        active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                      } flex justify-between w-full px-4 py-2 text-sm leading-5 text-left`}
                    >
                      Account Settings
                    </Link>
                  )}
                </Menu.Item>

                {SupportSectionEnabled ? (
                  <Menu.Item>
                    {({ active }) => (
                      <a
                        href="/support"
                        className={`${
                          active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                        } flex justify-between w-full px-4 py-2 text-sm leading-5 text-left`}
                      >
                        Support
                      </a>
                    )}
                  </Menu.Item>
                ) : (
                  <></>
                )}
              </div>

              <div className="py-1">
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={() => logout()}
                      className={`${
                        active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                      } flex justify-between w-full px-4 py-2 text-sm leading-5 text-left`}
                    >
                      Sign Out
                    </button>
                  )}
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </div>
      )}
    </Menu>
  );
};

export default UserMenu;
